export const bootstrapMDWidth = 991;

export const MOBILE_MEDIA_QUERY = '(max-width: 768px)';

export function getIsMobile(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(MOBILE_MEDIA_QUERY).matches
  );
}

export const getCurrentWindowSize = (): number => window.innerWidth || document.documentElement.clientWidth;

export const getBoundingClientRect = (query: string) =>
  document.querySelector(query) && document.querySelector(query).getBoundingClientRect();
